export enum ProviderGapStatus {
  Danger = 'danger',
  Warning = 'warning',
  Success = 'success',
}

export const getProviderGapStatusDecorator = (
  gainsPercent: number,
  impactsPercent: number,
  servesPercent: number,
  passPercentage: number,
): ProviderGapStatus => {
  if (gainsPercent > 0 || impactsPercent < 100) {
    if (impactsPercent >= passPercentage) {
      return ProviderGapStatus.Success;
    } else if (impactsPercent >= 25.0) {
      return ProviderGapStatus.Warning;
    }
  } else {
    if (servesPercent >= passPercentage) {
      return ProviderGapStatus.Success;
    } else if (servesPercent >= 25.0) {
      return ProviderGapStatus.Warning;
    }
  }

  return ProviderGapStatus.Danger;
}
